import React, { useState, useEffect } from "react";
import {
  DownOutlined,
  IssuesCloseOutlined,
  StarFilled,
} from "@ant-design/icons";
import { List, Button, Badge, Empty, Dropdown, Menu } from "antd";
import { PropTypes } from "prop-types";
import { useTranslation } from "react-i18next";

export default function PendingApprovalLeaveWidget({
  isLoading,
  pendingLeaveApproval,
  history,
}) {
  const { t } = useTranslation();
  const [hasPendingApproval, setHasPendingApproval] = useState(false);

  const menu = (
    <Menu
      onClick={handleMenuClick}
      items={[
        {
          label: t("pendingApprovalLeaveWidget.leave_approval"),
          key: "1",
        },
        {
          label: t("pendingApprovalLeaveWidget.leave_cancellation"),
          key: "2",
        },
      ]}
    ></Menu>
  );

  function onView() {
    const approveLeave = pendingLeaveApproval.pendingleaveInfo.filter(
      (x) => x.Status === 1 || x.Status === 4
    );
    const cancelLeave = pendingLeaveApproval.pendingleaveInfo.filter(
      (x) => x.Status !== 1 && x.Status !== 4
    );

    if (approveLeave.length > 0) {
      const minYear = Math.min(...approveLeave.map((item) => item.Year));
      history("/home/leaveapplicationapproval", {
        state: {
          year: minYear,
        },
      });
    } else {
      const minYear = Math.min(...cancelLeave.map((item) => item.Year));
      history("/home/leaveapplicationcancel", {
        state: {
          year: minYear,
        },
      });
    }
  }

  function handleMenuClick(e) {
    const approveLeave = pendingLeaveApproval.pendingleaveInfo.filter(
      (x) => x.Status === 1 || x.Status === 4
    );
    const cancelLeave = pendingLeaveApproval.pendingleaveInfo.filter(
      (x) => x.Status !== 1 && x.Status !== 4
    );

    if (e.key === "1") {
      const minYear = Math.min(...approveLeave.map((item) => item.Year));
      history("/home/leaveapplicationapproval", {
        state: {
          year: minYear,
        },
      });
    } else {
      const minYear = Math.min(...cancelLeave.map((item) => item.Year));
      history("/home/leaveapplicationcancel", {
        state: {
          year: minYear,
        },
      });
    }
  }

  useEffect(() => {
    setHasPendingApproval(pendingLeaveApproval.pendingAmount > 0);
  }, [pendingLeaveApproval]);

  return (
    <div style={{ display: !isLoading ? "block" : "none" }}>
      <div style={{ textAlign: "center", margin: "10px auto" }}>
        <Badge
          className="dashboard-badge"
          count={
            <StarFilled
              style={
                hasPendingApproval ? { display: "none" } : { color: "#3498db" }
              }
            />
          }
        >
          <div className="pending-number">
            {pendingLeaveApproval.pendingAmount}
          </div>
        </Badge>
      </div>
      <div
        style={
          hasPendingApproval
            ? {
                marginTop: "15px",
                height: "195px",
                backgroundColor: "#f5f7fa",
                borderRadius: "10px",
                overflow: "auto",
              }
            : { display: "none" }
        }
      >
        <List
          itemLayout="horizontal"
          dataSource={pendingLeaveApproval.pendingleaveInfo}
          renderItem={(item) => (
            <List.Item>
              <div className="attendance-code" style={{ color: item.LTColor }}>
                {item.LTCode}
              </div>
              <List.Item.Meta
                style={{ padding: "0 10px 0 0" }}
                title={item.EmpyName}
              />
            </List.Item>
          )}
        />
      </div>
      <div
        style={
          hasPendingApproval ? { display: "none" } : { padding: "10px 0 10px" }
        }
      >
        <Empty
          image="https://gw.alipayobjects.com/mdn/miniapp_social/afts/img/A*pevERLJC9v0AAAAAAAAAAABjAQAAAQ/original"
          imageStyle={{
            height: 60,
            display: "none",
          }}
          description={
            <span>
              {t("pendingApprovalLeaveWidget.no_more_pending_request")}
            </span>
          }
        ></Empty>
      </div>
      <div className="dashboard-card-button" style={{ textAlign: "right" }}>
        <Button
          type="primary"
          icon={<IssuesCloseOutlined />}
          onClick={() => onView && onView()}
          style={{
            display: !pendingLeaveApproval.isMixStatus ? "" : "none",
          }}
        >
          {t("pendingApprovalLeaveWidget.view_request")}
        </Button>

        <Dropdown
          dropdownRender={() => menu}
          style={{
            display: pendingLeaveApproval.isMixStatus ? "" : "none",
          }}
        >
          <Button
            type="primary"
            icon={<IssuesCloseOutlined />}
            style={{
              display: pendingLeaveApproval.isMixStatus ? "" : "none",
            }}
          >
            {t("pendingApprovalLeaveWidget.view_request")} <DownOutlined />
          </Button>
        </Dropdown>
      </div>
    </div>
  );
}

PendingApprovalLeaveWidget.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  pendingLeaveApproval: PropTypes.object.isRequired,
  history: PropTypes.func.isRequired,
};
